module.exports = __webpack_public_path__ + "img/icon_check_default.482fc216.svg";